import React, { Component } from 'react';

import '../../css/bg.css';
import '../../css/main-page.css';

import routeConfig from '../../config/route.json';
import comingSoonConfig from '../../config/coming-soon.json';

import $ from 'jquery';
import ScrollArea from 'react-scrollbar';


class TenderDocuments extends Component {

  constructor(props) {
    super(props);
    // let lang = window.location.hash.split('/')[1];
    let pathArr = window.location.pathname.split('/');
    let lang = pathArr[2] === '' ? 'en' : pathArr[2];


    this.state = {
      ...this.props,
      bg: {
        pic1: '/p2/desktop/bg/' + lang + '/tender-documents/main.png',
        pic2: '/p2/desktop/bg/' + lang + '/tender-documents/2.png',
        pic3: '/p2/desktop/bg/' + lang + '/tender-documents/3.png',
        pic4: '/p2/desktop/bg/' + lang + '/tender-documents/4.png',
      },
      lang: lang
    }
    $('#loader').fadeIn();
  }
  
  componentWillMount() {
    
  }
  
  componentDidMount() {
    let t = this;

    const toFunc = function(){
      console.log('polling t.props.data...')
      if (typeof t.props.data !== 'undefined') {
        t.setState({
          data: t.props.data
        });
      } else {
        t.t0 = setTimeout(toFunc, 500);
      }
    }

    this.t0 = setTimeout(toFunc, 500);

    this.props.updateLang();
    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);
    
    $( "#bg-image-1" ).on('load', function() {
      t.pageLoad();
    });
    
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);
    
    clearTimeout(this.t0);

    clearTimeout(this.bgAnimTimeout1);
    clearTimeout(this.bgAnimTimeout2);
    clearTimeout(this.bgAnimTimeout3);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();

    this.bgAnimTimeout1 = setTimeout(function(){
      document.getElementById('bg-image-2').classList.remove('bg-flower');
    }, 2200);
    this.bgAnimTimeout2 = setTimeout(function(){
      document.getElementById('bg-image-3').classList.remove('bg-flower');
    }, 3000);
    this.bgAnimTimeout3 = setTimeout(function(){
      document.getElementById('bg-image-4').classList.remove('bg-flower');
    }, 3900);
  }

  changePositioning() {
    let windowWidth = $('.App').width();

    if (windowWidth < 1100) {
      windowWidth = 1100
    }

    let bgImage2Top = windowWidth * 278/1100 + 'px';
    let bgImage3Top = windowWidth * 460/1300 + 'px';
    let bgImage4Top = windowWidth * 425/1100 + 'px';

    document.getElementById('bg-image-2-container').style.top = bgImage2Top;
    document.getElementById('bg-image-3-container').style.top = bgImage3Top;
    document.getElementById('bg-image-4-container').style.top = bgImage4Top;

    if ($('.App').height() < 805) {
      $('.main-page-content-container').css({
        'top': '17%'
      })
    }
    console.log("$('.App').height()" + $('.App').height())
    $('.main-page-content-container').css({
      'height': $('.main-page-content-container').width() * 0.6 + 'px'
    })
    // $('.main-page-content-content').css({
    //   'height': $('.main-page-content-content').width() * 0.6 * 0.8 + 'px'
    // })
    $('.main-page-content-content').css({
      'height': '140px'
    })
  }
  
  render() {
    let t = this;
    return <div className="main-page" style={{}}>

        <img src={this.state.bg.pic1} className='bg-image' id='bg-image-1' style={{}}/>


        <div id='bg-image-2-container'
          className='bg-image-container'
          style={{
            left: '0',
            width: '21%',
          }}>
          <img src={this.state.bg.pic2} className='bg-image bg-flower' id='bg-image-2'/>
        </div>

        <div id='bg-image-3-container'
          className='bg-image-container'
          style={{
            right: '0%',
            width: '23%'
          }}>
          <img src={this.state.bg.pic3} className='bg-image bg-flower' id='bg-image-3'/>
        </div>
        <div id='bg-image-4-container'
          className='bg-image-container'
          style={{
            left: '0%',
            width: '38%'
          }}>
          <img src={this.state.bg.pic4} className='bg-image bg-flower' id='bg-image-4'/>
        </div>

        <div id=''
          className='main-page-content-container'
          style={{
            left: '10%',
            width: '28%',
            top: '17%',
            height: '100px'
          }}>
          <div
            className='main-page-content-subtitle'
            style={{
              fontSize: '20px',
              textShadow: '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000',
              padding: this.state.lang === 'en' ? '' : '9px'
            }}>
            {this.state.lang === 'en' ? 
              <img style={{height: '88px'}} src={routeConfig.tenderDocuments[this.state.lang].titleUrl}/> : 
              routeConfig.tenderDocuments[this.state.lang].name
            }
          </div>
          <br/>

          <ScrollArea
            speed={0.8}
            className='main-page-content-content'
            style={{
              paddingLeft: '10px',
              fontSize: '14px',
              overflowX: 'hidden'
            }}
            verticalContainerStyle={{
              opacity: '0.6',
              width: '9px',
              borderRadius: '4.5px',
              backgroundColor: 'white',
              zIndex: '1000'
            }}
            verticalScrollbarStyle={{
              marginLeft: '0',
              width: '9px',
              borderRadius: '4.5px',
              backgroundColor: '#ecacd2',
            }}
            horizontal={true}
            vertical={true}
            >
            {this.state.data && this.state.data.tender_document && this.state.data.tender_document.length > 0 ?
              this.state.data.tender_document.map(function(elem, idx) {
              return <a className='item-button' key={idx} href={elem.url} target='_blank' style={{

                }}>
                <div className={'item-text ' + (t.state.lang == 'en' ? 'item-is-eng' : 'item-is-chi')} style={{
                  padding: '6px 0',
                  // 'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000',
                  textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 2px, rgba(0, 0, 0, 0.5) 1px 1px 1px, rgba(0, 0, 0, 0.5) 1px 1px 2px',
                }}>
                  {elem[t.state.lang]}
                </div>
              </a>
              }) : <div style={{
                color: 'white',
                padding: '6px 0',
                // 'textShadow': '2px 2px 3px #000, 1px 1px 1px #000, 3px 3px 3px #000',
                textShadow: 'rgba(0, 0, 0, 0.5) 1px 1px 2px, rgba(0, 0, 0, 0.5) 1px 1px 1px, rgba(0, 0, 0, 0.5) 1px 1px 2px',
              }} className={'item-text'}>{comingSoonConfig[t.state.lang]}</div>
            }
          </ScrollArea>

        </div>
    </div>
  }
};

export default TenderDocuments;



// WEBPACK FOOTER //
// ./src/desktop/page/TenderDocuments.js